import { Flex } from 'component-library/components/layout/Flex';
import { ResponsiveHeading } from 'component-library/components/typography/ResponsiveHeading';
import { WrapperLarge } from 'page-components/about-us/shared/WrapperLarge';
import React, { FC } from 'react';
import styled from 'styled-components';

import { ThreeStepSectionProps } from '.';
import { Step } from './Step';

const Image = styled.div`
  flex-basis: 50%;
  margin: auto;
`;

const Steps = styled(Flex)`
  padding-left: 40px;
  flex-basis: 50%;
  gap: 56px;
  max-width: 600px;
`;

const StyledWrapperLarge = styled(WrapperLarge)`
  margin-top: -16%;
`;

const StyledResponsiveHeading = styled(ResponsiveHeading)`
  max-width: 70%;
`;

interface ThreeStepSectionLargeProps extends ThreeStepSectionProps {}

export const ThreeStepSectionLarge: FC<ThreeStepSectionLargeProps> = ({
  steps,
  image,
  heading,
}) => (
  <StyledWrapperLarge maxWidth={1568} spacing={80}>
    <StyledResponsiveHeading marginBottom={80} variant={2}>
      {heading}
    </StyledResponsiveHeading>
    <Flex justifyContent="space-between">
      <Image>{image}</Image>
      <Steps column justifyContent="center">
        {steps.map((step, idx) => (
          <Step {...step} key={idx} />
        ))}
      </Steps>
    </Flex>
  </StyledWrapperLarge>
);
